!function() {
  "use strict";
  const e = async ({ shopDomain: e2, accessToken: r2, query: t2, variables: a2 }) => {
    try {
      const i2 = `https://${e2}/api/2024-07/graphql.json`, c2 = { "X-Shopify-Storefront-Access-Token": r2, "Content-Type": "application/json" }, n2 = await fetch(i2, { method: "POST", headers: c2, body: JSON.stringify({ query: t2, variables: a2 }) });
      return await n2.json();
    } catch (e3) {
      throw console.log("error", e3), e3;
    }
  };
  function r(e2) {
    if (!Array.isArray(e2) || 0 === e2.length) return [];
    const r2 = e2[0];
    return "customerGroupId" in r2 ? (t2 = e2, Array.isArray(t2) ? t2.map((e3 = {}) => {
      const { customerGroupId: r3 = "", customerTag: t3 = "", type: a2 = "WHOLESALE", wholesalePrice: i2 = null, quantityPrice: c2 = {} } = e3;
      let n2 = false;
      "QUANTITY" === a2 && (n2 = !!c2.isVariantUnique);
      let o = [];
      return "WHOLESALE" === a2 && null != i2 ? o.push({ quantity: "1", price: i2 }) : Array.isArray(c2.value) && (o = c2.value), { customerGroupId: r3, customerTag: t3, markets: [{ handle: "", currency: "", pricing: { type: o.length > 1 ? "QUANTITY" : "WHOLESALE", strategy: "A", isVariantUnique: n2, priceSource: "R", values: o } }] };
    }) : []) : "i" in r2 ? function(e3) {
      if (!e3 || !Array.isArray(e3)) return null;
      return e3.map((e4 = {}) => {
        let [r3 = "", t3 = ""] = (e4.i || "").split("~");
        return { customerGroupId: r3, customerTag: t3, markets: e4.p.split("|").map((e5) => {
          let [r4 = "", t4 = "", a2 = "A", i2 = "0", c2 = "R", n2 = ""] = e5.split("~"), o = n2.split(";").map((e6) => {
            let [r5 = "1", t5 = "0"] = e6.split(":");
            return { quantity: r5, price: t5 };
          }) ?? [];
          return { handle: r4, currency: t4, pricing: { type: o.length > 1 ? "QUANTITY" : "WHOLESALE", strategy: a2, priceSource: c2, isVariantUnique: "1" === i2, values: o } };
        }) };
      });
    }(e2) : [];
    var t2;
  }
  function t(e2, r2) {
    if (null === e2) return "";
    const t2 = "string" == typeof e2 ? parseFloat(e2) : e2, a2 = t2.toFixed(2), i2 = t2.toFixed(0), c2 = a2.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","), n2 = i2.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return r2.replace("{{amount}}", a2).replace("{{amount_no_decimals}}", i2).replace("{{amount_with_comma_separator}}", c2).replace("{{amount_no_decimals_with_comma_separator}}", n2);
  }
  function a(e2, r2, a2) {
    var _a;
    let i2 = "", c2 = "", n2 = "", o = "", l = ((_a = e2.pricingRule) == null ? void 0 : _a.markets[0]) ?? null;
    if (!l) return { retailPriceText: "", compareAtPriceText: "", savingsText: "", maxRetailPriceText: "" };
    let s = l.pricing.type;
    return "QUANTITY" === s ? { retailPriceText: i2, compareAtPriceText: c2, savingsText: n2, maxRetailPriceText: o } = function(e3, r3, a3, i3) {
      let c3 = i3.pricing.strategy, n3 = i3.pricing.values, o2 = i3.currency, l2 = e3.price.currencyCode, s2 = "R" === i3.pricing.priceSource ? e3.price.amount : e3.compareAtPrice.amount, p = window.marketConversionRate;
      if (!s2 || "" === s2) return { retailPriceText: "", compareAtPriceText: "", savingsText: "", maxRetailPriceText: "" };
      let u = n3.filter((e4) => Number(e4.quantity) <= a3).reduce((e4, r4) => Number(r4.quantity) > Number(e4.quantity) ? r4 : e4, { price: "0", quantity: "0" }).price;
      if (o2 !== l2 && "" !== o2) {
        if (!p || !p.conversion_rate) return { retailPriceText: "", compareAtPriceText: "", savingsText: "", maxRetailPriceText: "" };
        ["A", "F"].includes(c3) && (u = (parseFloat(u) * p.conversion_rate).toFixed(2).toString());
      }
      let d = "A" === c3 ? u : "P" === c3 ? (parseFloat(s2) * (1 - parseFloat(u) / 100)).toFixed(2).toString() : "F" === c3 ? (parseFloat(s2) - parseFloat(u)).toFixed(2).toString() : e3.price.amount;
      if ("" === o2 && p && p.base_currency !== l2) return { retailPriceText: "", compareAtPriceText: "", savingsText: "", maxRetailPriceText: "" };
      (parseFloat(d) < 0 || parseFloat(d) > parseFloat(e3.price.amount)) && (d = e3.price.amount);
      let y = t(d, clayProductPriceConfig.priceDisplayText), m = t(s2, clayProductPriceConfig.compareAtPriceDisplayText), P = "amountPerUnit" === clayProductPriceConfig.savingsDisplayType ? (parseFloat(s2) - parseFloat(d)).toFixed(2) : "percentage" === clayProductPriceConfig.savingsDisplayType ? ((parseFloat(s2) - parseFloat(d)) / parseFloat(s2) * 100).toFixed(0) : 0, g = t(P, clayProductPriceConfig.savingsDisplayText);
      return p && (y = window.clayCurrencySymbol + parseFloat(d).toFixed(2), m = window.clayCurrencySymbol + parseFloat(s2).toFixed(2), g = "Save " + clayProductPriceConfig.savingsDisplayType == "amountPerUnit" ? window.clayCurrencySymbol + P : "percentage" === clayProductPriceConfig.savingsDisplayType ? P + "%" : ""), { retailPriceText: y, compareAtPriceText: m, savingsText: g, maxRetailPriceText: "" };
    }(e2, 0, a2, l) : "WHOLESALE" === s && ({ retailPriceText: i2, compareAtPriceText: c2, savingsText: n2, maxRetailPriceText: o } = function(e3, r3, a3) {
      let i3 = a3.pricing.strategy;
      a3.pricing.values;
      let c3 = a3.currency, n3 = e3.price.currencyCode, o2 = window.marketConversionRate, l2 = "R" === a3.pricing.priceSource ? e3.price.amount : e3.compareAtPrice.amount, s2 = a3.pricing.values[0].price;
      if (!l2 || "" === l2) return { retailPriceText: "", compareAtPriceText: "", savingsText: "", maxRetailPriceText: "" };
      if (c3 !== n3 && "" !== c3) {
        if (!o2 || !o2.conversion_rate) return { retailPriceText: "", compareAtPriceText: "", savingsText: "", maxRetailPriceText: "" };
        ["A", "F"].includes(i3) && (s2 = (parseFloat(s2) * o2.conversion_rate).toFixed(2).toString());
      }
      let p = "A" === i3 ? s2 : "P" === i3 ? (parseFloat(l2) * (1 - parseFloat(s2) / 100)).toFixed(2).toString() : "F" === i3 ? (parseFloat(l2) - parseFloat(s2)).toFixed(2).toString() : e3.price.amount;
      if ("" === c3 && o2 && o2.base_currency !== n3) return { retailPriceText: "", compareAtPriceText: "", savingsText: "", maxRetailPriceText: "" };
      (parseFloat(p) < 0 || parseFloat(p) > parseFloat(e3.price.amount)) && (p = e3.price.amount);
      let u = t(p, clayProductPriceConfig.priceDisplayText), d = t(l2, clayProductPriceConfig.compareAtPriceDisplayText), y = "amountPerUnit" === clayProductPriceConfig.savingsDisplayType ? (parseFloat(l2) - parseFloat(p)).toFixed(2) : "percentage" === clayProductPriceConfig.savingsDisplayType ? ((parseFloat(l2) - parseFloat(p)) / parseFloat(l2) * 100).toFixed(0) : 0, m = t(y, clayProductPriceConfig.savingsDisplayText);
      return o2 && (u = window.clayCurrencySymbol + parseFloat(p).toFixed(2), d = window.clayCurrencySymbol + parseFloat(l2).toFixed(2), m = "Save " + clayProductPriceConfig.savingsDisplayType == "amountPerUnit" ? window.clayCurrencySymbol + y : "percentage" === clayProductPriceConfig.savingsDisplayType ? y + "%" : ""), { retailPriceText: u, compareAtPriceText: d, savingsText: m, maxRetailPriceText: "" };
    }(e2, 0, l)), { retailPriceText: i2, compareAtPriceText: c2, savingsText: n2, maxRetailPriceText: o };
  }
  async function i(t2) {
    const a2 = window.clayStorefrontConfig || {}, i2 = window.clayCustomerTier || {}, c2 = window.clayCustomerTags || [], n2 = window.clayCountryIsoCode, { allVariants: o } = await (async (t3, a3, i3, c3, n3, o2) => {
      var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l;
      try {
        let l, s = true, p = [];
        for (; s; ) {
          const u = await e({ shopDomain: t3, accessToken: a3, query: `query fetchProductVariantMetafield($handle: String!, $country: CountryCode) @inContext(country: $country){
                    product(handle: $handle) {
                        title
                        handle
                        variants(first: 250,after: ${l ? `"${l}"` : "null"}){
                            edges{
                                node{
                                    id
                                    title
                                    metafield(namespace: "app--173437812737--clay", key: "pricing_rule"){
                                        value
                                        type
                                    }
                                    price{
                                      amount
                                      currencyCode
                                    }
                                    compareAtPrice{
                                      amount
                                      currencyCode
                                    }
                                }
                            }
                            pageInfo{
                                hasNextPage
                                endCursor
                            }
                        }
                    }
                }`, variables: { handle: i3, country: o2 } });
          if (!((_a = u.data) == null ? void 0 : _a.product)) return s = false, console.log("No products found"), [];
          const d = (_d = (_c = (_b = u.data) == null ? void 0 : _b.product) == null ? void 0 : _c.variants) == null ? void 0 : _d.edges.map((e2) => {
            var _a2;
            const t4 = e2.node, a4 = t4.id.split("/").pop(), i4 = (_a2 = t4.metafield) == null ? void 0 : _a2.value, o3 = r("string" == typeof i4 ? JSON.parse(i4) : []);
            let l2 = o3.find((e3) => e3.customerGroupId === c3 || n3.includes(e3.customerTag));
            l2 || (l2 = o3.find((e3) => "ALL" === e3.customerGroupId));
            const s2 = window.clayMarketHandle;
            if (window.clayCountryCurrency, l2) {
              let e3 = l2.markets.find((e4) => e4.handle === s2 || "" === e4.handle && "" === e4.currency) || null;
              if (e3) {
                const r2 = { ...l2, markets: [e3] };
                return { id: a4, title: t4.title, pricingRule: r2, price: t4.price, compareAtPrice: t4.compareAtPrice };
              }
            }
            return { id: a4, title: t4.title, pricingRule: null, price: t4.price, compareAtPrice: t4.compareAtPrice };
          });
          p.push(...d), s = (_h = (_g = (_f = (_e = u.data) == null ? void 0 : _e.product) == null ? void 0 : _f.variants) == null ? void 0 : _g.pageInfo) == null ? void 0 : _h.hasNextPage, l = (_l = (_k = (_j = (_i = u.data) == null ? void 0 : _i.product) == null ? void 0 : _j.variants) == null ? void 0 : _k.pageInfo) == null ? void 0 : _l.endCursor;
        }
        return { handle: i3, allVariants: p };
      } catch (e2) {
        throw console.error("Error fetching product metafield:", e2), e2;
      }
    })(a2.shopDomain, a2.token, t2, "" === i2.customerGroupId ? "LOGGED_IN" : i2.customerGroupId, c2, n2);
    return o;
  }
  async function c() {
    n({ productGrid: ".cm_product-item", productGridProductUrl: ".cm_product-item__title", productGridProductPrice: ".cm_product-item__price", retailPriceBlockFormatOnCollectionsPage: "<span>{retailPriceText}</span>", comparePriceBlockFormatOnCollectionsPage: '<span>{retailPriceText} &nbsp; </span><span style="text-decoration: line-through;">{compareAtPriceText}</span>' }, 0, 1e4, 0);
  }
  function n(e2, r2, t2, c2) {
    let o = document.querySelectorAll(e2.productGrid);
    o = Array.from(o).filter((r3) => {
      const t3 = r3.querySelector(e2.productGridProductPrice);
      return t3 && !t3.classList.contains("clay-wholesale-price");
    }), o && o.length > 0 && o.length !== c2 && function(e3, r3) {
      e3.forEach(async (e4, t3) => {
        let c3 = function(e5) {
          let r4 = null;
          const t4 = e5.match(/\/products\/([^/?#]+)/);
          return t4 && t4[1] && (r4 = decodeURIComponent(t4[1])), r4;
        }(e4.querySelector(r3.productGridProductUrl).href);
        const n2 = e4.querySelector(r3.productGridProductPrice);
        if (!n2 || n2.classList.contains("clay-wholesale-price")) return;
        !async function(e5, r4, t4) {
          e5.sort((e6, r5) => parseFloat(e6.price.amount) - parseFloat(r5.price.amount));
          const i2 = e5[0];
          if (!i2.pricingRule) return;
          const c4 = r4.querySelector(t4.productGridProductPrice), { retailPriceText: n3, compareAtPriceText: o2, savingsText: l, maxRetailPriceText: s } = a(i2, 0, 1);
          if ("" === n3) return;
          const p = function(e6, r5, t5, a2) {
            if (r5.comparePriceBlockFormatOnCollectionsPage && t5 !== a2) return r5.comparePriceBlockFormatOnCollectionsPage;
            if (r5.comparePriceBlockFormatOnProductPage && t5 !== a2) return r5.comparePriceBlockFormatOnProductPage;
            return r5.retailPriceBlockFormatOnCollectionsPage || r5.retailPriceBlockFormatOnProductPage || "{retailPriceText}";
          }(0, t4, n3, o2);
          let u = function(e6, r5, t5, a2, i3) {
            return e6.replace("{retailPriceText}", r5).replace("{compareAtPriceText}", t5).replace("{savingsText}", a2).replace("{maxRetailPriceText}", i3);
          }(p, n3, o2, l, s);
          c4.classList.contains("clay-wholesale-price") || (c4.innerHTML = u, c4.classList.add("clay-wholesale-price"));
        }(await i(c3), e4, r3);
      });
    }(o, e2), r2 < t2 && setTimeout(() => {
      n(e2, r2 + 200, t2, o.length);
    }, 200);
  }
  !function() {
    window.addEventListener("popstate", c);
    const e2 = history.pushState;
    history.pushState = function() {
      e2.apply(this, arguments), c();
    };
    const r2 = history.replaceState;
    history.replaceState = function() {
      r2.apply(this, arguments), c();
    }, c();
  }();
}();
